export type WorkspaceViewId='operations'|'my_field_jobs'|'administration';

export type WorkspaceView={id:WorkspaceViewId;label:string};

export type WorkspaceViewModel={views:WorkspaceView[];defaultView:WorkspaceViewId|null};

const orderedViews:WorkspaceView[]=[
  {id:'operations',label:'Operations'},
  {id:'my_field_jobs',label:'My field jobs'},
  {id:'administration',label:'Administration'},
];

const operationsCapabilities=['company_operations','mission_control','fulfillment_routing','profenz_operations','external_payment_confirmation'] as const;
const fieldCapabilities=['server_work_queue'] as const;
const administrationCapabilities=[
  'profenz_workspace_setup','process_server_onboarding','process_server_roster',
  'company_assignment_management','company_administrator_invitations',
  'control_plane_access_suspension','internal_mfa_requirements','email_intake_settings',
] as const;

function record(value:unknown):value is Record<string,unknown>{return value!==null&&typeof value==='object'&&!Array.isArray(value);}
function hasLiteralCapability(capabilities:Record<string,unknown>,names:readonly string[]):boolean{
  return names.some(name=>capabilities[name]===true);
}

/** Presentation-only view discovery. Server authorization remains authoritative for every route. */
export function workspaceViewModel(context:unknown):WorkspaceViewModel{
  if(!record(context)||!record(context.capabilities))return {views:[],defaultView:null};
  const capabilities=context.capabilities;
  const allowed=new Set<WorkspaceViewId>();
  if(hasLiteralCapability(capabilities,operationsCapabilities))allowed.add('operations');
  if(hasLiteralCapability(capabilities,fieldCapabilities))allowed.add('my_field_jobs');
  const canInviteManagedServers=capabilities.onboarding_delivery===true
    && capabilities.company_managed_process_server_enrollment===true;
  const canSeePlatformAdministration=capabilities.platform_owner===true
    && Array.isArray(context.role_codes)
    && context.role_codes.includes('profenz_executive_authority');
  if(hasLiteralCapability(capabilities,administrationCapabilities)||canInviteManagedServers||canSeePlatformAdministration)allowed.add('administration');
  const views=orderedViews.filter(view=>allowed.has(view.id));
  return {views,defaultView:views[0]?.id??null};
}
